<ng-container *transloco="let t;">
  <form [formGroup]="profileForm" (ngSubmit)="verify()">
    <p class="wc-content">
      {{ forgotpass ? t("challenge.ForgotPasswordOTPContent") : t("OTP Content") }}
    </p>
    <div *ngIf="showError" class="warning-info">{{ t("InvalidOtp") }}</div>
    <div fxLayout="column" class="otp-input-wrapper">
      <p class="otp-info" *ngIf="!otpReSent">{{ t("challenge.TypeVerificationCode") }}</p>
      <p class="otp-info" *ngIf="otpReSent">{{ t("challenge.ReSentOtpInfo") }}</p>
      <div>
        <input class="otp-input" numbersOnly placeholder="------" type="text" pattern="^[0-9]*$" maxlength="6"
          onkeypress="if(this.value.length ==6) return false" onkeyup="if(this.value.length == 6) this.blur()"
          formControlName="otp" />
      </div>
      <div fxLayout fxLayoutGap="20px" fxLayoutAlign="center center" class="timer-wrapper">
        <span fxLayout fxLayoutAlign="start center" class="otp-timer" *ngIf="!hasResend">{{ t("challenge.otpTimerInfo") }} <span
            class="clock" style="margin-left: 8px;"></span>
          {{ counter | formatTime }}</span>
        <a class="resend-button" (click)="resendOtp()" *ngIf="hasResend">{{
          t("challenge.ResendOtp")
          }}</a>
      </div>
    </div>
    <div style="margin-top: 20px;">
      <button *ngIf="!showSpinner" [disabled]="profileForm.invalid || hasResend" type="submit" mat-flat-button fxFlex.gt-sm="100"
        color="primary" class="verify-button">
        {{ t("challenge.Verify") }}
      </button>
      <button *ngIf="showSpinner" fxFlex.gt-sm="100" [disabled]="profileForm.invalid" mat-flat-button color="primary" class="spinner-button" class="verify-button">
       {{ t("challenge.Verify") }}
      </button>
    </div>
  </form>
</ng-container>